import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckRanConsistencyStatuses } from '@api/consistencyCheck';

import { optionsFormattedByTitleName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_RAN_CONSISTENCY_STATUSES } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckRanConsistencyStatuses {
	consistencyOptions: TSelectOption<string>[];
	isLoadingConsistencyOptions: boolean;
}

const useQueryConsistencyCheckRanConsistencyStatuses = (): IUseQueryConsistencyCheckRanConsistencyStatuses => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONSISTENCY_RAN_CONSISTENCY_STATUSES],
		queryFn: getConsistencyCheckRanConsistencyStatuses,
		select: (data) => optionsFormattedByTitleName(data),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyOptions: data || [],
		isLoadingConsistencyOptions: isInitialLoading,
	};
};

export default useQueryConsistencyCheckRanConsistencyStatuses;
